<template>
  <div
    class="reserve gw"
    :class="[deviceType(), isNa ? 'na' : '']"
  >
    <div
      class="p1"
      id="kv"
      name="kv"
    >
      <!-- 背景图 -->
      <div
        class="kv"
        v-if="deviceType() == 'wap'"
      >
        <img src="../../assets/images/video/na-wap-gw.jpg">
        <!-- <img
          v-else
          src="../../assets/images/gw-p1.jpg"
        > -->
      </div>
      <div
        class="kv"
        v-else
      >
        <div>
          <img
            v-if="XhLang == 'en'"
            src="../../assets/images/video/na-pc-gw-en.jpg"
          >
          <img
            v-if="XhLang == 'th'"
            src="../../assets/images/video/na-pc-gw-th.jpg"
          >
          <img
            v-if="XhLang == 'cn'"
            src="../../assets/images/video/na-pc-gw-cn.jpg"
          >
        </div>
        <!-- <div v-else>
          <img
            v-if="XhLang == 'en'"
            src="../../assets/images/gw-p1-en.jpg"
          >
          <img
            v-if="XhLang == 'th'"
            src="../../assets/images/gw-p1-th.jpg"
          >
          <img
            v-if="XhLang == 'cn'"
            src="../../assets/images/gw-p1-cn.jpg"
          >
        </div> -->
      </div>
      <div
        class="title"
        :class="XhLang"
        style="z-index: 4;"
        v-if="deviceType() == 'wap'"
      ></div>
      <!-- 视频播放 -->
      <video-info :VideoData="VideoData"></video-info>
      <!-- 下载按钮 -->
      <div class="down_module">
        <!-- 二维码 -->
        <div
          class="qrcode"
          v-if="deviceType() == 'pc'"
        >
          <img :src="store.state.articlesData.gwQRcode">
        </div>
        <down-info
          :position="'gw'"
          :iosCounts="'market_above_ios'"
          :androidCounts="'market_above_gp'"
          :apkCounts="'market_above_apk'"
          :huaweiCounts="'market_above_huawei'"
          :FBCounts="'market_above_FB'"
          :finger="1"
          :initState="initState"
        ></down-info>
      </div>
    </div>
    <!-- 储值教学 -->
    <tutoring-info v-if="deviceType() == 'pc'"></tutoring-info>
    <float-info
      v-if="deviceType() == 'wap'"
      :scroll="scrollTop"
    ></float-info>
    <div
      class="p2 gw"
      id="role"
      name="registrations"
    >
      <role-info :RoleData="RoleData"></role-info>
    </div>
    <div
      class="p3"
      id="game"
      name="game"
    >
      <div
        class="title"
        :class="XhLang"
      ></div>
      <game-info :BannerData='BannerData'></game-info>
    </div>
    <div
      class="p4"
      id="info"
      name="info"
    >
      <div
        class="page"
        :class="XhLang"
      >
        <facebook-page
          :link="store.state.articlesData['fbPage' + XhLang.toUpperCase()]"
          :width="896"
          :height="1264"
        ></facebook-page>
      </div>
    </div>
    <!-- 菜单 -->
    <nav-info
      :ShareData="ShareData"
      :activityEnd="activityEnd"
    ></nav-info>
    <!-- 侧边栏 -->
    <side-info
      :scroll="scrollTop"
      :activityEnd="activityEnd"
    ></side-info>
    <!-- 底部信息 -->
    <xh-foot
      :email="projectType().email"
      :name="projectType().name"
      :type="'gw'"
    ></xh-foot>
  </div>
</template>

<script setup>
import sideInfo from "./com/sideInfo.vue";
import navInfo from "./com/navInfo.vue";
import gameInfo from "./com/gameInfo.vue";
import tutoringInfo from "./com/tutoring.vue";
import downInfo from "@/components/down.vue";
import roleInfo from "./com/role.vue";
import videoInfo from "@/components/video.vue";
import floatInfo from "./com/float.vue";

import { onUnmounted, ref, reactive, onBeforeMount, computed } from "vue";
import { useI18n } from "vue-i18n";

import {
  deviceType,
  bottomScroll,
  parseUrl,
  scrollToSpecificHeight,
} from "@/util/base";
const { locale } = useI18n();
const XhLang = locale.value;

import { useRouter } from "vue-router";
const router = useRouter();
// 定义一个映射对象，用于将标签名映射到对应的处理函数
const currentPath = router.currentRoute.value.path;

import { useStore } from "vuex";
const store = useStore();

const isNa = computed(() => projectType().area.indexOf("na") !== -1);

import XhFoot from "@/components/foot.vue";
import facebookPage from "@/components/third/facebookPage.vue";

import commonModel from "@/api/common";
// import { Decrypt } from "@/api/sign";
import { projectType } from "@/util/global";
import { ReviseMeta, shareMeta } from "@/util/meta";
import { articles, columns, init, getServerTime } from "@/api/construct";
import { deploy } from "@/util/deploy";

const scrollTop = ref("");
const reserveData = ref("");
const LinkData = ref("");
const ShareData = ref("");
const VideoData = ref("");
const BannerData = ref("");
const RoleData = ref("");
const areaCodeData = ref(""); // Set a default selected option
const initState = ref(false);
const activityEnd = ref(false);

const first = ref(false);

const handleScroll = () => {
  scrollTop.value =
    document.documentElement.scrollTop || document.body.scrollTop;
  if (bottomScroll()) {
    if (!userStatus.store_button && !userStatus.reserve) {
      first.value = true;
    }
  }
};

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

// 获取预约下载&第三方配置
const getDeploy = async (id) => {
  const res = await articles(id);
  if (res.data.articles_list && res.data.articles_list.length > 0) {
    LinkData.value = res.data.articles_list[0].articles_info;
    first.value = true;

    const deployData = deploy(LinkData.value, currentPath);
    // 将处理好的数据通过 Vuex 存储
    store.dispatch("updateArticlesData", deployData);

    console.log("获取预约下载&第三方配置", deployData);
  } else {
    console.log("获取预约下载&第三方配置 失败");
  }
};

const getVideo = async () => {
  var articlesRes;
  articlesRes = await articles(36);
  if (
    articlesRes.data.articles_list &&
    articlesRes.data.articles_list.length > 0
  ) {
    const newArticles = articlesRes.data.articles_list.map((article) => ({
      ...article.articles_info,
    }));
    VideoData.value = [...VideoData.value, ...newArticles];
  } else {
    console.log("No articles found for getVideo");
  }
};

const getShare = async () => {
  var articlesRes;
  if (XhLang == "cn") {
    articlesRes = await articles(14);
  } else if (XhLang == "en") {
    articlesRes = await articles(15);
  } else if (XhLang == "th") {
    articlesRes = await articles(16);
  }
  if (
    articlesRes.data.articles_list &&
    articlesRes.data.articles_list.length > 0
  ) {
    ShareData.value = articlesRes.data.articles_list[0].articles_info;
    const shareLink = window.location.href;
    let shareTitle = "";
    let shareImg = "";
    for (const item of ShareData.value) {
      if (item.label === "shareTitle") {
        shareTitle = item.content;
      }
      if (item.label === "shareImg") {
        shareImg = item.content;
      }
    }
    shareMeta(shareLink, shareTitle, shareImg, reserveData.value.description);
    console.log("ShareData", ShareData.value[0]);
  } else {
    console.log("No articles found for category");
  }
};

// 获取关键词，标题，描述
const getMeta = async (id) => {
  const res = await columns(id);
  if (res.data && res.data.category_list) {
    for (var i in res.data.category_list) {
      if (res.data.category_list[i].id == 1) {
        reserveData.value = res.data.category_list[i];
        // 修改标题，关键词，描述
        ReviseMeta(
          reserveData.value.title,
          reserveData.value.keywords,
          reserveData.value.description
        );
      }
    }
  }
};

// 根据语言获取banner
const getBanner = async () => {
  var articlesRes;
  if (XhLang == "cn") {
    articlesRes = await articles(10);
  } else if (XhLang == "en") {
    articlesRes = await articles(11);
  } else if (XhLang == "th") {
    articlesRes = await articles(12);
  }
  if (
    articlesRes.data.articles_list &&
    articlesRes.data.articles_list.length > 0
  ) {
    const newArticles = articlesRes.data.articles_list.map((article) => ({
      ...article.articles_info,
    }));
    BannerData.value = [...BannerData.value, ...newArticles];
  } else {
    console.log("No articles found for getBanner");
  }
};

// 根据角色
const getRole = async () => {
  var articlesRes;
  articlesRes = await articles(35);
  if (
    articlesRes.data.articles_list &&
    articlesRes.data.articles_list.length > 0
  ) {
    const newArticles = articlesRes.data.articles_list.map((article) => ({
      ...article.articles_info,
    }));
    RoleData.value = [...RoleData.value, ...newArticles];
    console.log("TutorData", RoleData);
  } else {
    console.log("No articles found for getRole");
  }
};

let userStatus = reactive({});

// 获取ip
const getAreaCode = async () => {
  let res = await commonModel.getAreaCode();
  if (res.data && res.data.area_code) {
    areaCodeData.value = res.data.area_code;
  }
};

// 获取活动信息
const getActivityInfo = async () => {
  let res = await commonModel.getActivityInfo();
  if (res.data && res.data.end_time) {
    if (Math.floor(Date.now() / 1000) > res.data.end_time) {
      activityEnd.value = true;
    }
  }
};

onBeforeMount(async () => {
  await getServerTime();
  await getAreaCode();
  await init();
  initState.value = true;
  // 并发请求获取文章列表、栏目列表
  await Promise.all([
    // 获取预约下载&第三方配置
    getDeploy(9),
    // 获取banner栏目
    getBanner(),
    // 获取角色
    getRole(),
    // 获取关键词，标题，描述
    await getMeta(0),
    // 获取分享配置
    getShare(),
    // 获取YouTube视频配置
    getVideo(),
    // 获取活动信息
    getActivityInfo(),
  ]);
  window.addEventListener("scroll", handleScroll);
  if (parseUrl(window.location.href).position == "role") {
    scrollToSpecificHeight(600);
  }
});
</script>

<style lang="scss" src="../../assets/css/index.scss" scoped></style>